<script lang="ts">
import EntryScreen from './components/EntryScreen.vue';
import EntryInputScreen from './components/EntryInputScreen.vue';
import EntryList from './components/EntryList.vue';
import ChooseCategory from './components/ChooseCategory.vue';


import HelloWorld from './components/HelloWorld.vue'
import Category from './components/Category.vue';
// import Data from './ts/Data';
import CategoryData from './ts/DataTypes/CategoryData';
import 'material-icons/iconfont/material-icons.css';
import { defineComponent, VueElement } from 'vue'

import StaticVars from "./ts/StaticVars";
import {ModalInfo} from "./ts/StaticVars";
import ModalVue from './components/Modal.vue';
import InputTextSmart, { ObjectIn } from './components/InputTextSmart.vue';
// import { db, PopulateTestData, UserDB, PopulateIfEmpty } from './ts/DexieDB';
import UserSelectVue from './components/UserSelect.vue';
import Button from './components/Button.vue';
import { UserPrefs } from './ts/UserPrefs';
import { ExportImport } from './ts/ExportImport';

import Loading_Icon from './components/Loading_Icon.vue';

import UserEditScreen from './components/UserEditScreen.vue';
import CatEditScreen from './components/CatEditScreen.vue';
import MaterialIconsList from './ts/MaterialIconsList';
//to be able to declare constants/ static variables, doesn't seem to be a way to do it on a vue component, but can do it on view itself:
//https://stackoverflow.com/questions/50587636/where-to-store-static-content-e-g-country-codes-in-a-vue-js-app

import { createClient } from '@supabase/supabase-js'
import DataSupaBase from'./ts/DataSupaBase'
import Data from './ts/Data';
import type { EntryDB } from './ts/DataTypes/Entry';
import type Entry from './ts/DataTypes/Entry';
import { EntryAttributeDB } from './ts/DexieDB';
import { Browser } from '@capacitor/browser';

//more stuff for capacitor
// import { App, URLOpenListenerEvent } from '@capacitor/app';
import { App } from '@capacitor/app';

import { Capacitor } from '@capacitor/core';








//if you have "Setup" above - at allows it to find the components being used... but also doesn't like the "export default" on define component
export default defineComponent({
 

  //have to define the components we want to use if not using "setup" above- using setup above also doesn't let us define our component like this...
  components: { Category, ChooseCategory, EntryScreen, EntryList, ModalVue, InputTextSmart, UserSelectVue, Button, EntryInputScreen, Loading_Icon, UserEditScreen, CatEditScreen },
  props:
  {
  },
  data() 
  {
    return {
      // categories: new Array()
        // icon:{ type:String, default:"home"},
        // text:{ type:String, default:"Go Home"}
        // current_screen:StaticVars.SCREENS.ENTRY_INPUT, //for testing entry input
        current_screen:StaticVars.SCREENS.HOME,
        extra_data:{},
        show_modal:false,
        modal_info:new ModalInfo({}),//all the stuff sent to the modal

        testing_input:false,
        input_def_value:"Constipation",
        input_test_data: ([{"id":5,"name":"Explosive diarrhea","date_updated":new Date("2023-03-15T00:29:05.502Z")},{"id":7,"name":"yellow water","date_updated":new Date("2023-03-14T19:29:05.502Z")},{"id":3,"name":"Diarrhea","date_updated":new Date("2023-03-14T09:29:05.502Z")},{"id":4,"name":"Constipated","date_updated":new Date("2023-03-13T16:29:05.502Z")},{"id":6,"name":"Hard Bunny poos","date_updated":new Date("2023-03-06T17:29:05.502Z")}] as unknown as Array<ObjectIn>),
        
        
        user_current_id:"1",//for having multiple users able to use the app- DexieJS seems to default to "1" ONE as it's first index
        // users:[] as Array<UserDB>,
        // user_current:{} as UserDB,

        parent_loaded_can_mount_children:false, //hack- vue will mount child components before a parent component- so have to have a v-if on children, which only renders them after the parent is mounted
        force_vue_update_key:0,// to force vue to update when this variable changes

        editing_cat_from_entry_list:false, //for if we're editing a cat from the entry list- should leave the entry list up in the background
		cat_changed:false, //just for entry list to refresh if a entry is added, and has a new entry potentially

		//for converting from dexiejs/ offline to supabase/ online
		signed_in_to_google:false,
		supabase:{} as any,
		user:{} as any,//supabase user
		data:{} as DataSupaBase,
		cats:[] as CategoryData[],

		//from entrylist:
		entries:new Array<Entry>(),
        cats_w_entries:new Array<CategoryData>(),

		test_url:0,
		back_function:()=>{console.log("no back function defined")},
		added_or_updated_new_entry_id:"-1",//for when added a new entry- to scroll to it after the page change

		cat_ids_w_prev_entries:new Array<any>(), //format: {cat_id:id, entries: Array<string>}for cat ids with prev entries in it- to cache so we don't have to keep asking the server for the same cat_id

		// recent_entries_for_cat:[] as EntryDB[], // to have a list of recent entries to pass for auto completing when someone is trying to add a new one
    }
  },
  watch : 
  {
      current_screen:function(current_screen) 
      {
          console.log("watch current_screen called");      
		  
		 this.ScrollToEntry();
      },  
  },

  async mounted()
  {
    console.log("App moounted");

    

    console.log("Testing EXPORT!");
    // await ExportImport.Export();
    // await ExportImport.Import();
	// this.SetupBackButtonCatcher();

    ExportImport.SetupImportButton();

    console.log("App mounted");

	//setup supabase
	console.log("Creating new superbase data");
	this.data = new DataSupaBase();
	this.supabase=this.data.supabase;


    //FROM CHATGPT on signing in with capacitor, have to update it to handle the way it does below, and comment this out!!
    this.handleOAuthRedirectFromDeepLinkCapacitor();

  //log out for testing
  // const { error } = await this.data.supabase.auth.signOut()
  // console.log("logged out: ", error);

	console.log("HandlingUserIsLoggedIn");
	this.user = await this.data.GetUser();
	this.SetUserSignedIn();
	//get categories

  if(this.signed_in_to_google)
	await this.GetCats();


    this.data.GetRealTimeEntryUpdates(this.RealTimeUpdateReceieved);

	// this.GetRecentEntries();



    //get the user set from userprefs
    // this.user_current_id =  UserPrefs.user_selected.value;
    // console.log("Set user selected from user prefs: ", this.user_current_id);

	// await PopulateIfEmpty();
	// console.log("\n\nApp, done populate if empty\n\n");

    // await this.UserChanged();

	// (window as any).Data=Data; //so we can access Data from window for debugging

    // throw new Error("whoops");
    

    //testing getting user by timestamp:
    // console.log("getting user by timestamp!");
    // await Data.GetUserByTimeStamp(1684884152000);
    

    //ONLY REAL WAY TO GET THE CURRENT ROUTE
    //finally- the only thing that will allow you to get the current route
    // this.$router.isReady().then(() => 
    // {
    //   router.push("/choosecategory");
    // });
    
    // let value = await Data.GetCategories() as Array<CategoryData>;
    // console.log("APp, got data for categories: ", value);
    // this.categories = value;
    // console.log("APp finished!");

    this.parent_loaded_can_mount_children=true;

	this.SetupBackButtonIssues();
	
  },
  methods:
  {
	ScrollToEntry()
	{
		if(this.added_or_updated_new_entry_id!="-1")
		{			
			this.$nextTick(()=>{
          
			console.log("App: going to scroll to new entry");
			(this.$refs.entrylist as typeof EntryList).ScrollToEntryByID(this.added_or_updated_new_entry_id);
			this.added_or_updated_new_entry_id="-1";			
		});
		}
	},
	SetupBackButtonIssues()
	{
		//if we have a forward slash from last time/ refresh at some point, can remove the fragment/ left over url:
		// remove fragment as much as it can go without adding an entry in browser history:
		//doesn't work
		/* console.log("getting rid of fragment");
		window.location.replace("#");

		// slice off the remaining '#' in HTML5:    
		if (typeof window.history.replaceState == 'function') {
		history.replaceState({}, '', window.location.href.slice(0, -1));
		} */


		//works- on mouse up, for adding to the history- but mouse move doesn't- no referenes on which things count
		// window.addEventListener('mouseup', ()=>{history.pushState({info:"was home page"}, `was home page`, `was home page`);});
		
		//this does give a warning if they try to use back to leave- but also if they just refresh the page, which I don't want
		/* window.addEventListener('beforeunload', function (event) {

				event.preventDefault();
				console.log("beforeunload fired");
				event.returnValue = 'Are you sure you want to leave this page?';
				return event.returnValue;
			}); */
    
		// MaterialIconsList.CleanData();
		window.addEventListener('popstate', (info) => {
			console.log("back button fired");
			this.HardwareBackButtonPressed(info);
			});
			
	},
	//to call when either the android back button has been pressed, or the back button on the browser
	HardwareBackButtonPressed(info:any)
	{
		console.log("hardware back button pressed, info: ", info);
		(this.back_function as any)(this.SwitchScreen);
		
	},
	//need to say what the current page is (to go back to on back button press- physical or in the UI), and what Page we're going to go to
	RegisterMovingFowardInternal(next_page:string)
	{
		history.pushState({info:next_page}, `${next_page}`, `${next_page}`);
		console.log("adding to history: ", next_page);
	},

	//for the hardware back buttons to know which Back Function to call when the button is pressed
	//pass to other screens to register their back buttons with the hardware back buttons
	//back button function will get passed switch screen function
	BackButtonRegister(back_function:Function)
	{
		(this.back_function as any) = back_function;
	},
	async GetCats()
	{
		this.cats = await this.data.GetCats();

		//populate default cats
		if(this.cats.length<1)
		{
			console.log("no default cats for user, adding them now");
			let result = await this.data.AddCats(StaticVars.cats_default) as[];

      result.forEach((row:any) => {
        console.log("adding new categories from supa to local cats")
        this.cats.push(new CategoryData({id:row.id, name:row.name, type:row.type, color_bg:row.color_bg, color_txt:row.color_txt, icon:row.icon, date_updated:new Date(row.updated_at) }));  
      });

      
		}
		else //add new default cats as I add them
		{
		//compare static cats and our cats
		let new_cats = StaticVars.cats_default.filter((cat_default)=>{

			let new_cat=true;
			this.cats.forEach(cat_existing => {
			if(cat_default.type==cat_existing.type)
				new_cat=false;
			});
			if(new_cat)
			{
				console.log("going to  add to cats new cat: ",cat_default);
				return cat_default;
			}
		});

		if(new_cats.length>0)
		{
			console.log("going to  add to new cats: ",new_cats);

			let result = await this.data.AddCats(new_cats)  as[];

			result.forEach((row:any) => 
			{
				console.log("adding new categories from supa to local cats", row)
				this.cats.push(new CategoryData({id:row.id, name:row.name, type:row.type, color_bg:row.color_bg, color_txt:row.color_txt, icon:row.icon, date_updated:new Date(row.updated_at) }));  
			});
			}
		}
	},
	async GetPrevEntriesForCat(id_cat:string)
	{
		//cat_ids_w_prev_entries
		//check if we already grabbed it:
		let prev_cat = undefined;
		let prev_entries=new Array<ObjectIn>();
		// this.cat_ids_w_prev_entries.forEach(element => {
		for (let i = 0; i < this.cat_ids_w_prev_entries.length; i++) 
		{
			const element = this.cat_ids_w_prev_entries[i]
			if(element.id_cat==id_cat)
			{
				// prev_entries=element.entries;
				prev_cat=element;
				break;
			}			
		}
		if(prev_cat)
		{
			prev_entries=prev_cat.entries;
		}
		else
		{
			prev_entries = await this.data.GetEntriesPrevForCategory(id_cat);
			this.cat_ids_w_prev_entries.push({id_cat:id_cat, entries:prev_entries});
		}
		console.log("GetPrevEntriesForCat: cat id: ", id_cat, "prev entries: ", prev_entries);

		return prev_entries;
	},

	async GetPrevAttributesForCat(id_cat:string)
	{
		return await this.data.GetPrevAttributesForCat(id_cat);
	},

	//from entryList DeleteClicked
	async DeleteEntryClicked(extra_info:Object)
	{
		console.log("DeleteEntryClicked", extra_info);
		let modal_info = new ModalInfo({text: "Are you sure your want to delete this entry?", callback_yes: async ()=>{console.log("yes clickedDD");await this.DeleteEntryFinal(extra_info)}, callback_no:()=>{console.log("no clickedDD")}});
		this.ShowModalAdvanced(modal_info);
	},
	async DeleteEntryFinal(extra_info:any)
	{
		console.log("Delete Entry extra info: ", extra_info);
		extra_info.predelete();
		let entry_to_delete= extra_info.entry;

		//lets do it locally first
		this.cats_w_entries.forEach((cat)=>{
			if(cat.id==entry_to_delete.id_cat)
					cat.entries = cat.entries.filter((entry)=>{
				if(entry.id==extra_info.entry.id)
					console.log("deleting entry locally", entry);
				else 
					return entry;
				});
		});
		console.log("DeleteEntryFinal: deleted entry locally, now entries are: ", this.cats_w_entries);

		//also looks like it actually deleted locally/ showing in UI with deletion, so don't have to do hack to create new cats
		let error = await this.data.EntryDelete(entry_to_delete.id)
		console.log("App: DeleteEntryFinal: error: ", error);
		// await Data.DeleteEntry(extra_info);
	},

	async CategoryDelete(cat:CategoryData)
	{
		console.log("CategoryDelete  Finalextra info: ", cat.id);


		//lets do it locally first
		this.cats_w_entries = this.cats_w_entries.filter((cat_existing)=>{
				if(cat_existing.id==cat.id)
					console.log("deleting cat locally", cat_existing);
				else 
					return cat_existing;
				
		});
		this.cats = this.cats.filter((cat_existing)=>{
				if(cat_existing.id==cat.id)
					console.log("deleting cat locally2", cat_existing);
				else 
					return cat_existing;
				
		});
		console.log("CategoryDelete: deleted entry locally, now entries are: ", this.cats_w_entries);

		this.ForceCatRefresh();
		this.ForceCatWEntriesRefresh();

		//also looks like it actually deleted locally/ showing in UI with deletion, so don't have to do hack to create new cats

		//probably only need to do this because I am actually using cats_w_entries
		let error = await this.data.CategoryDelete(cat.id)
		console.log("App: DeleteCategoryFinal: error: ", error);
		// await Data.DeleteEntry(extra_info);
	},

	
    /* async UserChanged()
    {

      console.log("user changed");
      this.users = await Data.GetUsers();

      
      let user = await Data.GetUserByID(this.user_current_id);

      //if default user doesn't exist, use ANY user instead to prevent a crash
      if(!user)
      {
          user = await Data.GetFirstUser();
          if(!user)
            this.ShowModal("No users in database found, can't create default view without a user... create new user? ", async ()=>{
              // user = await Data.AddUser("New User");
              await PopulateTestData();
              user = await Data.GetFirstUser();
              this.ReloadPage();
            });
      }

      this.user_current = new UserDB(user);
      console.log("user data = ", this.user_current, "this name: ", this.user_current.name);
    }, */
   
    
	MoveForwardToPage(screen_num:number, extra_data?:any)
	{
		this.RegisterMovingFowardInternal("ScreenNum_"+screen_num);
		this.SwitchScreen(screen_num, extra_data);
	},

    //for handling switching screens
    SwitchScreen(screen_num:number, extra_data?:any)
    {
		// console.log("DEBUG CAT ENTRIES, Data.cats[1].entries : ",Data.cats[1].entries );
      console.log("switch screen called!, ", screen_num, extra_data);
	  if(extra_data)
		if(extra_data.cat_changed)
			this.cat_changed=true;
      
      //for if editing a cat from the home screen/ entry list, keep them in the background/ state up
      this.editing_cat_from_entry_list=false;

	//   if(screen_num==StaticVars.SCREENS.HOME)
	//   {
	// 		if(this.cat_changed)
	// 		{
	// 			this.cat_changed=false;
	// 			//refresh entry list, since new cat + entry created/ needs to grab new data from database
	// 			// (this.$refs.entrylist as typeof EntryList).UpdateCatsAfterAddOrUpdate(extra_data.cat);
	// 		}
	// 	}

	// let dont_go_back=false;//for cat switch screen- to not go back, since history.back will be called

      if(this.Home)
      {
        if(screen_num==StaticVars.SCREENS.CAT_EDIT)
		{
        	this.editing_cat_from_entry_list=true;
			extra_data.last_screen=StaticVars.SCREENS.HOME;
		}
      }
      else if(this.OnCatEditScreen)
      {
		if(extra_data) //on back button, extra data can't be provided
        if(extra_data.cat_changed)
        {
          //for refresh on the cats in the entry list
		  console.log("going to update the cats displayed in the one that was updated from Entry Editable", extra_data);
		// (extra_data as any).UpdateCatsChanged();

          //have to wait until it switches screen

		  if(screen_num==StaticVars.SCREENS.HOME)
          	(this.$refs.entrylist as typeof EntryList).UpdateCatsAfterAddOrUpdate(extra_data.cat);
		// else if(screen_num==StaticVars.SCREENS.ENTRY_INPUT)
		// 	(this.$refs.entry_input as typeof EntryInputScreen).UpdateCatsAfterAddOrUpdate(extra_data.cat);

          // this.$nextTick(()=>{
          //   (this.$refs.entrylist as typeof EntryList).UpdateCatsAfterAddOrUpdate();
          // });
		  //this works, but shouldn't go all the way back if prev screen was entry input
		//   history.back();
		//   dont_go_back=true;
		  
        }

		//if we went back from edit cats to entry input, need to re-register the back button
		if(screen_num==StaticVars.SCREENS.ENTRY_INPUT)
		{
			(this.$refs.entry_input as typeof EntryInputScreen).ReRegisterBackBtn()
		}
      }
	  

      this.extra_data=extra_data;
	//   if(!dont_go_back)
      	this.current_screen=screen_num;

	//   console.log("DEBUG CAT ENTRIES, Data.cats[1].entries : ", Data.cats[1].entries );
    },
    ShowModal(text:string, callback_yes:Function|undefined=undefined, callback_no:Function|undefined=undefined, text_input:boolean=false)
    {
      console.log("App: ShowModal clicked!, callback_yes: ", callback_yes);
      
      this.modal_info.text= text;
      this.modal_info.callback_yes= callback_yes;
      this.modal_info.callback_no= callback_no;
      this.modal_info.text_input=text_input;
      if(!callback_yes)
        this.modal_info.only_one_btn=true;
      else
        this.modal_info.only_one_btn=false;

        console.log("this.modal_info.only_one_btn: ", this.modal_info.only_one_btn)

      this.show_modal=true;
      // this.modal_info = {text:text, callback_yes:callback_yes, callback_no:callback_no};
    },

    //because I want to control one button or not, not automatically
    ShowModalAdvanced(extra_info:ModalInfo)
    {
      console.log("App: ShowModalAdvanced clicked!, callback_yes: ", extra_info);
      
      this.modal_info.text= extra_info.text;
      this.modal_info.callback_yes= extra_info.callback_yes;
      this.modal_info.callback_no= extra_info.callback_no;
      this.modal_info.text_input=extra_info.text_input;

      this.modal_info.only_one_btn=extra_info.only_one_btn||false;

        console.log("this.modal_info.only_one_btn: ", this.modal_info.only_one_btn)

      this.show_modal=true;
      // this.modal_info = {text:text, callback_yes:callback_yes, callback_no:callback_no};
    },
    CloseModal()
    {
      console.log("App: CloseModal clicked!");
      this.show_modal=false;
    },
    /* async UserSelected(user:UserDB)
    {
      
      // this.user_current = new UserDB(user);
      this.user_current_id= user.id;

      //save it in userprefs
      UserPrefs.SavePref(UserPrefs.user_selected.name, user.id);

      // console.log("current user changed to: ", this.user_current);
      await this.UserChanged();
    }, */
   /*  async AddUser(username:string)
    {
      //have to add a new user from Data
      let user = await Data.AddUser(username);
      this.UserSelected(user);
    }, */
    SwitchToEntryInput()
    {
      this.MoveForwardToPage(StaticVars.SCREENS.ENTRY_INPUT);
	  //should close any entry being edited 
	  (this.$refs.entrylist as typeof EntryList).CloseOpenEntry()
    },
    async Export()
    {
      await ExportImport.Export();
    },
    async Import()
    {
      console.log("import clicked");
      await ExportImport.Import(
      ()=>{
        this.ShowModal("Import Finished, reloading app",undefined, ()=>{this.ReloadPage();})
      
      }
      );
    
    },
	async SignOut()
    {
        const { error } = await this.data.supabase.auth.signOut()
  		console.log("logged out: ", error);
		this.ReloadPage();
    },

    //for deleting everything- in case the database/ local variables are corrupted
    /* DeleteAll()
    {
      this.ShowModal("Are you sure you want to delete everything? Make sure you export all your data before doing this, or you can't get anything back.", 
        async ()=>{
          //actually delete everything
          //delete all localstorage, and indexdb

          //indexeddb- gone

          //eh- firefox is the only browser tht doesm't let you get a list of the database names
          // const dbs = await window.indexedDB.databases()
          // dbs.forEach(db => { window.indexedDB.deleteDatabase(db.name as string) })

          //have to close dexiejs connection if open
          db.close();

          //just deleting it by name
          window.indexedDB.deleteDatabase("HealthTracker");


          //local storage- gone
          localStorage.clear();

          //should also reset/ restart the component
          console.log("reloading app");
          // this.force_vue_update_key++;
          this.ReloadPage(); 
        },
      );

    },  */
	/* DeleteAllTables()
    {
      this.ShowModal("Are you sure you want to delete everything? Make sure you export all your data before doing this, or you can't get anything back.", 
        async ()=>{
          //actually delete everything
          //delete all localstorage, and indexdb

          //indexeddb- gone

          //eh- firefox is the only browser tht doesm't let you get a list of the database names
          // const dbs = await window.indexedDB.databases()
          // dbs.forEach(db => { window.indexedDB.deleteDatabase(db.name as string) })

          //have to close dexiejs connection if open
        //   db.close();

          //just deleting it by name
		  //deleteing all tables
		  db.users.clear();
		  db.cats.clear();
		  db.entries.clear();
		  db.entry_attributes.clear();
		  db.item_types.clear();

        
          //should also reset/ restart the component
          console.log("reloading app");
          // this.force_vue_update_key++;
          this.ReloadPage(); 
        },
      );

    },  */

    ReloadPage()
    {
      location.reload(); 
    },





	SetUserSignedIn()
	{
		console.log("SetUserSignedIn: User: ", this.user);
		if(this.user)
			if(this.user.id)
      {        
				this.signed_in_to_google=true;
        console.log("SetUserSignedIn: signed_in_to_google: ", this.signed_in_to_google);
      }
	},

	

	UpdateCatUpdatedLocally(cat_id:string)
	{
		//should also update the updated at on cats locally
		this.cats.forEach((cat_local)=>{

		if(cat_local.id==cat_id)
		{
			cat_local.date_updated = new Date();
			console.log("updated cat local1: ", cat_local.name);
		}

		});
		this.cats_w_entries.forEach((cat_local)=>{

			if(cat_local.id==cat_id)
			{
				cat_local.date_updated = new Date();
				console.log("updated cat local2: ", cat_local.name);
			}
		});

		//also have to sort them by date_updated
		//@ts-ignore
		this.cats = (this.cats as Array<CategoryData>).toSorted((a:Entry, b:Entry) => b.date_updated.getTime()-a.date_updated.getTime() );

		//@ts-ignore
		this.cats_w_entries = (this.cats_w_entries as Array<CategoryData>).toSorted((a:Entry, b:Entry) => b.date_updated.getTime()-a.date_updated.getTime() );

		// this.SetupCats();
		// this.ForceCatWEntriesRefresh();
		// this.ForceCatRefresh();
		// this.cats_w_entries = [];

	},

	/**
	 * For being able to populate entry fields with previous entries for that cat
	 */
	// async GetPreviousEntriesForCat(cat_id:string)
	// {
	// 	//for now, we'll just 
	// },

	//for passig down to EntryInput, to call with a new Entry to add in the database
    //only local for if updating already from supabase, don't want to tell it again to update
	async AddOrEditEntry(entries:Array<Entry>, only_local:boolean=false)
	{
		//should also add/edit this category locally
		console.log("Adding Or editing entry locally");

        //check if new, since if it's new from real time updates, it will already have an id, even though it isn't an update
        let does_not_exist=true;
        if(only_local)
        {
            does_not_exist = !(this.cats_w_entries.some(cat => cat.entries.some(entry => entry.id === entries[0].id && entry.date_updated==entries[0].date_updated)));
            console.log("exists: ", does_not_exist);
        }


		let result= undefined;

		if(entries.length>1||(!entries[0].id||!does_not_exist))//if for inserting multiple entries or adding new
		{
            console.log("adding new entry", entries[0]);
            if(!only_local)
			    result = await this.data.EntryAdd(entries);
            else
                result={data:entries}

			for (let i = 0; i < entries.length; i++) 
			{
				const entry = entries[i];					
				let entry_new = (result.data  as any)[i] ; //have it converting to a  new entry type before coming back

				//alert if error
				if(result.error)
					alert(result.error);

				this.UpdateCatUpdatedLocally(entry.id_cat);
				
				//add it locally
				for (let i = 0; i < this.cats_w_entries.length; i++) 
				{
					const cat = this.cats_w_entries[i];
				
					if(cat.id==entry.id_cat)
					{				
						console.log("Adding new entry,  cat.entries before: ",cat.entries);	
						// cat.entries = cat.entries.concat(entry_new);
						// cat.entries = cat.entries.concat(entry_new);//put the new entry at the front of the array- though they should be sorted by date updated instead...

						//because we're going to sort, can first just push it in the existing entry
						cat.entries.push(entry_new)
						//to sorted is the same as sort- but returns a new array
						//@ts-ignore
						cat.entries = (cat.entries as Array<Entry>).toSorted((a:Entry, b:Entry) => b.date_updated.getTime()-a.date_updated.getTime() );
						console.log("Adding new entry: ", entry_new, "to cat.entries: ",cat.entries);
						//should also highlight /scroll to new entry

						this.added_or_updated_new_entry_id=entry_new.id;

					}
				}
				

				//also have to add it to the previous entries- to the front/ organized by date
				this.UpdateEntriesPrevLocally(entry);					
			}
			this.ForceCatWEntriesRefresh();
			
		}
		else//if has an id updating
		{
			let entry= entries[0];

            if(!only_local)
			    result = await this.data.EntryUpdate(entry);
            else
                result={data:entries}

			//alert if error
			if(result.error)
				alert(result.error);

			let entry_new = (result.data as any)[0];

			this.UpdateCatUpdatedLocally(entry.id_cat);
			
			//add it locally
			for (let i = 0; i < this.cats_w_entries.length; i++) 
			{
				const cat = this.cats_w_entries[i];
			
				if(cat.id==entry.id_cat)
				{
					console.log("Adding new(update) entry,  cat.entries before: ",cat.entries);	

					//should also remove the entry that was there previously, to force it to update
					let entry_index=-1;
					for (let j = 0; j < cat.entries.length; j++) 
					{
						const entry_old = cat.entries[j];
						if(entry_old.id==entry_new.id)
						{
							entry_index=j;
							break;
						}
					}
					if(entry_index!=-1)
						cat.entries.splice(entry_index, 1);
					else
						console.error("Could not find existing entry we are trying to delete to update");


					// cat.entries = cat.entries.concat(entry_new);
					// cat.entries = cat.entries.concat(entry_new);//put the new entry at the front of the array- though they should be sorted by date updated instead...

					

					//because we're going to sort, can first just push it in the existing entry
					cat.entries.push(entry_new)
					//to sorted is the same as sort- but returns a new array
					//@ts-ignore
					cat.entries = (cat.entries as Array<Entry>).toSorted((a:Entry, b:Entry) => b.date_updated.getTime()-a.date_updated.getTime() );
					console.log("Adding new entry: ", entry_new, "to cat.entries: ",cat.entries);
					//should also highlight /scroll to new entry

					this.added_or_updated_new_entry_id=entry_new.id;

				}
			}

			//also have to add it to the previous entries- to the front/ organized by date
			this.UpdateEntriesPrevLocally(entry, entry);					
			
			this.ForceCatWEntriesRefresh();

			//just update it as if we were adding a new one

			//update it locally
			/* this.cats_w_entries.forEach((cat)=>{
				if(cat.id==entry.id_cat)
				{				
					console.log("Updating entry,  cat.entries before: ",cat.entries);	
					cat.entries = cat.entries.map((entry_existing)=>{
						if(entry_existing.id==entry.id)
						{
							this.UpdateEntriesPrevLocally(entry, entry_existing);

							entry_existing.Assign(entry);
							console.log("Edited existing entry, with it now being: ", entry_existing);
						}
						return entry_existing;
					});

					this.added_or_updated_new_entry_id=entry.id;
					this.ScrollToEntry();//have to manually call this, since not changing screens
					console.log("Edited entry: ", entry, "new version of cat.entries: ",cat.entries);
				}
			}); */
			// return result;			 
		}
		
		return result;


		
	},
	UpdateEntriesPrevLocally(entry_new:Entry, entry_old:Entry|undefined=undefined)
	{
		console.log("UpdateEntriesPrevLocally", entry_new, entry_old);
		for (let i = 0; i < this.cat_ids_w_prev_entries.length; i++) 
			{
				const element = this.cat_ids_w_prev_entries[i];
				if(element.id_cat==entry_new.id_cat)
				{
					if(entry_old)//if updating, have to remove the old name, and add it to the front
					{
						element.entries = (element.entries as Array<ObjectIn>).filter((entry)=>{
							if(entry.id!=entry_old.id)
								return entry;
							else
								console.log("updating old entry in pev entries: ", entry, "to new: ", entry_new)
						})
					}
					
					element.entries.unshift(new ObjectIn().Init(entry_new.id, entry_new.item_type, entry_new.date_updated));
					
				}				
			}
	},
	async GetEntriesByDateRange(date_start:Date, date_end:Date)
	{
		return await this.data.GetEntries(date_start, date_end)
	},
	//based on the one above, to get based on search term instead of date
	async GetEntriesBySearch(search_term:string)
	{

		this.entries = await this.data.GetEntriesBySearch(search_term);
		this.SetupCats()
	},
	async AddOrEditCat(cat:any)
	{
		let cat_new = await this.data.AddOrEditCat(cat);

		//it gets changed already, but not reflected in UI/ needs to be watched and updated
		if(cat.id)//if editing, need to update local copy
		{
			let index=-1;
			//update local cat - cat access the actual array with the 3 parameters
			this.cats.forEach((cat_local, i, arr)=>{
				if(cat_local.id==cat.id)
				{
					console.log("found local cat", cat_local, "updating to: ", cat_new);


					arr[i].Assign(cat_new);

					//if you replace an item in an array, you can't assign it a new object, replace it, update the object, etc- vue doesn't
					//fire on any update. Only array.splice to remove and re-add the same thing: splice(start, deleteCount, item0)
					//https://stackoverflow.com/questions/42807888/vuejs-and-vue-set-update-array
					//https://v2.vuejs.org/v2/guide/list.html#Array-Change-Detection
					// arr[i].Assign(cat_new);
					// arr[i].name=cat_new.name;
					// this.cats.splice(i, 1);//doesn't trigger anything, even though vue is supposed to on splice

					index=i;
					console.log("local cat updated to: ", this.cats[i]);

				}
			});
			// this.cats.splice(index, 1);//vue doesn't listen even for splice
			//this actually causes view to realize the cats object has changed- changing an element, splicing one out, etc, doesn't work.

			//have to hack it to force it to see the update
			//have to clear out the array- which vue actually does watch for, then can reassign the array again- which finally does work
			/* let cats_temp = this.cats;
			this.cats = [];
			this.$nextTick(()=>{
				this.cats = cats_temp;
          }); */
		  this.ForceCatRefresh();
			
		}
		else
		{
			//add the new cat
			console.log("App: Addeding new cat: ", cat_new);
			this.cats.push(new CategoryData(cat_new));//does actually work/ push changes to children
			console.log("App: Added new cat to cats :", this.cats);
		}

		return cat_new;

		//need to also update the local cat 
	},

	//vue is supposed to listen for when an array calls splice- but doesn't- think it's because the children display it, not the parent, so
	//it doesn't update the view/ doesn't do anything when you use splice. So instead have to create array as new, then put back in everything
	async ForceCatRefresh()
	{
		let cats_temp = this.cats;
			this.cats = [];
			this.$nextTick(()=>{
				this.cats = cats_temp;
          });
	},
	async ForceCatWEntriesRefresh()
	{
		let cats_temp = this.cats_w_entries;
			this.cats_w_entries = [];
			this.$nextTick(()=>{
				this.cats_w_entries = cats_temp;
          });
	},
	async AttributeCreateUpdateOrDelete(attributes:any, crud_operation:string)
	{
		let response = await this.data.AttributeCreateUpdateOrDelete(attributes, crud_operation);
		//should modify attributes locally to show them
		console.log("app AttributeCreateUpdateOrDelete : attributes", attributes, "crud_operation", crud_operation);
		console.log("app cats_w_entries before crudding", this.cats_w_entries);
		
			for (let i = 0; i < attributes.length; i++)
			{
				const attr = attributes[i];
					//find the attribute
					this.cats_w_entries.forEach(cat => {
						if(cat.id==attr.id_cat)
						{
							cat.entries.forEach(entry => {
								if(entry.id==attr.id_entry)
								{

									if(crud_operation=="create")//create and update
									{
										if(attr.id!=-1)//updating
										{
											console.log("foudn entry for attribute to update!!");
											entry.attributes.forEach(attr2 => {
												if(attr2.id==attr.id)
												{
													console.log("foudn attribute to update!! attr old: ", attr2, "new: ", attr);
													attr2.Assign(attr);
												}												
											});
										}//end of updating
										else//adding a new one
										{
											//also assign the id from supabase - should be in the same order as submitted
											let id = 123456789012345;//temp id for testing
											if(response)
												id=response[i].id;
											console.log("App, Adding new attribute locally + assigning it id:", id )
											attr.id=id;									
											entry.attributes.push(new EntryAttributeDB().Assign(attr));										
										}
									}//end of create/ updating an attribute
									else if(crud_operation=="delete")
									{
										entry.attributes = entry.attributes.filter(attr2 => {
											if(attr2.id==attr.id)
											{
												console.log("foudn attribute to delete!! attr old: ", attr2);
											}
											else
												return attr2;										
										});
									}
								}
								
							});
						}
						
					});
				
				
			}
		
		console.log("app cats_w_entries after crudding", this.cats_w_entries);
		this.ForceCatRefresh();

		return response;
	},



	// from EntryList- putting cats with entries + attributes out here, so everything can get access to them/ change when they do
	async GetEntriesInCatsByDateRange(date_start:Date, date_end:Date)
	{
		/* console.log("GetEntriesInCatsByDateRange: starting promise");
		let self=this;
		let promise = new Promise(async function(resolve, reject) {
		// the function is executed automatically when the promise is constructed
		
		// after 1 second signal that the job is done with the result "done"
		// setTimeout(() => {console.log("GetEntriesInCatsByDateRange promise: actually finished", );resolve("done")}, 2000);

		self.entries = await (self.GetEntriesByDateRange(self.date_start, self.date_end) as Promise<Entry[]>);
			resolve("done")
		});
		await promise;
		console.log("GetEntriesInCatsByDateRange: after promise"); */

		console.log("GetEntriesInCatsByDateRange1: ");
		this.entries = await this.GetEntriesByDateRange(date_start, date_end);

		console.log("GetEntriesInCatsByDateRange: ", this.entries, date_start, date_end)


		this.SetupCats()
		
	},
	async GetEntriesPrevForCategory(cat_id:string)
	{

	},
	async SetupCats()
	{
		//now add them to this cats
		this.cats_w_entries = this.cats.map((cat)=>{
			let new_cat = new CategoryData(cat);
			(new_cat as any).is_open=true;
			return new_cat;
		});

		// this.cats_w_entries = this.cats_w_entries.map((cat)=>{(cat as any).is_open=true;return cat});

		console.log("GetEntriesInCatsByDateRange2: entries:", this.entries, "cats_w_entries: ",this.cats_w_entries);
		this.entries.forEach((entry)=>{

			let cat_index=-1;
			
			for (let i=0;i<this.cats.length;i++)
			{
				let cat=this.cats[i];
			
				if(cat.id==entry.id_cat)
				{
					cat_index=i;
					break;
				}
			}
			
			if(cat_index!=-1)
				this.cats_w_entries[cat_index].entries.push(entry);

		});
	},
    async SignInToGoogle()
	{
		console.log("sign in to google: ");

        


		// let redirect_url = "http://127.0.0.1:5500/dist/"; //for testing
		let redirect_url = window.location.href;
		
		if(redirect_url.substring(redirect_url.length-1)=="#")
			redirect_url=redirect_url.substring(0, redirect_url.length-1);

		if(redirect_url.indexOf(".html")==-1)
			redirect_url+="index.html"

        if (Capacitor.getPlatform() === 'android') 
        {
            
            // redirect_url = 'https://healthtrackervue.app';
            redirect_url = 'https://ackmi.com/healthtrackervue';
            console.log("On android, redirecting to ", redirect_url)
        }

		
		
			//also gets mad if the hash tag is at the end, which it redirects to, so have to remove that too

		// alert("going to redirect afterwards to: "+ redirect_url);
        const { error, data } = await this.supabase.auth.signInWithOAuth({
		provider: 'google',
		
		options: {
			//this only works if it ends with index.html, or just the root folder- even if it shows index.heml in there- it won't work without an actual page name...
			//very particular/ will just sit with google waiting if the url isn't exactly what it expects
			redirectTo: redirect_url
		}
		});
        if (error) 
        {
            console.error('Error: ', error.message)
            alert("error gsignin: "+error.message)
            return
        }
        console.log("data from sign in with oauth: ", data)

        // if (data) 
        // {
        //     await Browser.open({ url: data.url })
        // }
		// redirectTo: window.location.href,//doesn't work right- works ok, but not fully-  needs to be inside options or it only partially redirects
	},

    /* async GoogleSignInCapacitor()
    {
        console.log(" GoogleSignInCapacitor called")
        let redirectTo = 'https://healthtrackervue.app';
        alert("going to sign in to google with capacitor href: \n"+window.location.href+", but really: \n"+redirectTo)
        //NOTE: in supabase, Auth, url config, have to specify redirect, or it will always go to:
        //http://10.0.0.39:5173

        const { error, data } = await this.supabase.auth.signInWithOAuth({
		provider: 'google',
		
		options: {
			//this only works if it ends with index.html, or just the root folder- even if it shows index.heml in there- it won't work without an actual page name...
			//very particular/ will just sit with google waiting if the url isn't exactly what it expects
			redirectTo: redirectTo
		}
		});

        if (error) 
        {
            console.error('Error: ', error.message)
            alert("error gsignin: "+error.message)
            return
        }

        if (data) 
        {
            await Browser.open({ url: data.url })
        }

    }, */
    async handleOAuthRedirectFromDeepLinkCapacitor() 
    {
        //going to use capacitor to check if we got a redirect from deep links:
        App.addListener('appUrlOpen', async (data) => {
        // Handle deep link URL here
        console.log('App2 URL Open', JSON.stringify(data));
        const url = data.url;

        // Create a URL object
        const urlObj = new URL(url);

        // Get the hash part of the URL
        const hash = urlObj.hash.substring(1); // Remove the leading '#'

        // Use URLSearchParams to extract parameters from the hash
        const params = new URLSearchParams(hash);

        // Extract individual parameters
        const accessToken = params.get('access_token');
        const expiresAt = params.get('expires_at');
        const expiresIn = params.get('expires_in');
        const providerToken = params.get('provider_token');
        const refreshToken = params.get('refresh_token');
        const tokenType = params.get('token_type');

        console.log('Access Token:', accessToken);
        console.log('Expires At:', expiresAt);
        console.log('Expires In:', expiresIn);
        console.log('Provider Token:', providerToken);
        console.log('Refresh Token:', refreshToken);
        console.log('Token Type:', tokenType);


        // Set the access token for the Supabase client
        //have to create the supabase client first
        console.log("this supabase: ", this.supabase, "auth: ", this.supabase.auth)
        //so we've already mounted, just going back into the app, so need to continue along the way?
        // this.supabase.auth.setSession(accessToken);
        const { data2, error } = await this.supabase.auth.setSession({
            access_token:accessToken,
            refresh_token:refreshToken
        })
        console.log("after set session, data2: ", JSON.stringify(data2), "error: ", JSON.stringify(error));

        //copied from mounted
        console.log("HandlingUserIsLoggedIn");
            this.user = await this.data.GetUser();
            this.SetUserSignedIn();
            //get categories

        if(this.signed_in_to_google)
            await this.GetCats();


        /* try 
        {
            const { user, error } = await this.supabase.auth.getUser();
            if (error) throw error;
                console.log('User info:', user);
            return user;
        } 
        catch (error) {
            console.error('Error getting user info:', error);
        } */

        });


      /* // Check if the URL has the access token or other information
      const urlParams = new URLSearchParams(window.location.search)
      const accessToken = urlParams.get('access_token')
      
      if (accessToken) {
        // Use the access token
        const { user, session, error } = await this.supabase.auth.setSession(accessToken)
        if (error) {
          console.error('Error setting session: ', error.message)
        } else {
          console.log('User: ', user)
          console.log('Session: ', session)
        }
        alert("user signed in!"+ JSON.stringify(user));
      } */
      
    },
    RealTimeUpdateReceieved(payload:any)
    {
        //structure: eventType (DELETE, INSERT, UPDATE), old.id, new (entry)

        console.log("App got an update to entries! :", payload);
        //so need to add it if we don't already have it

        //if delete, delete it if it exists
        if(payload.eventType=="DELETE")
        {
            
            //lets do it locally first
            this.cats_w_entries.forEach((cat)=>{
                
                        cat.entries = cat.entries.filter((entry)=>{
                    if(entry.id==payload.old.id)
                        console.log("deleting entry locally", entry);
                    else 
                        return entry;
                    });
            });
            console.log("DeleteEntryFinal: deleted entry locally, now entries are: ", this.cats_w_entries);
        }
        else if(payload.eventType=="INSERT")
        {
            //first make sure it doesn't already exist, in case we're the ones who made the entry/ already have it
            const exists = this.cats_w_entries.some(cat => cat.entries.some(entry => entry.id === payload.new.id));

            if(!exists)
            {
                console.log("Adding new entry from realtime");
                this.AddOrEditEntry([payload.new], true);
            }
            else
            console.log("Adding new entry from realtime, but already exists");
        }
        else if(payload.eventType=="UPDATE")
        {
            //first make sure it doesn't already exist, in case we're the ones who made the entry/ already have it, and the date is already the newest
            const exists = this.cats_w_entries.some(cat => cat.entries.some(entry => entry.id === payload.new.id && entry.date_updated==payload.new.date_updated));

            if(!exists)
            {
                console.log("Updating entry from realtime");
                this.AddOrEditEntry([payload.new], true);
            }
            else
            console.log("Updating new entry from realtime, but already have most recent update");

        }

    

    },


	
  },
  
  

    //computed- so we can pass variables into css without having to do javascript
    //from: https://stackoverflow.com/questions/42872002/in-vue-js-component-how-to-use-props-in-css
  computed: {

    //helper functions to set the selected screen
    Home(test:any){return this.current_screen==StaticVars.SCREENS.HOME;},
    ChooseCat(test:any){return this.current_screen==StaticVars.SCREENS.ChooseCat;},
    EntryScreen(test:any){return this.current_screen==StaticVars.SCREENS.EnterIntoCat;},
    OnEntryInputScreen(test:any){return this.current_screen==StaticVars.SCREENS.ENTRY_INPUT;},

    OnUserEditScreen(test:any){return this.current_screen==StaticVars.SCREENS.USER_EDIT;},
    OnCatEditScreen(test:any){return this.current_screen==StaticVars.SCREENS.CAT_EDIT;},
  },
  updated()
  {
  },
  setup()
  {
    
    
  }
})


//should probably return apromise
console.log("APp started!");

</script>

<template :key="force_vue_update_key">
  <!-- <div>Ok....</div> -->

  
  <!-- emergency export/ import / delete database controls -->
  <!-- <div class="export_import" v-if="!parent_loaded_can_mount_children">
          <Button text="Export" :callback="()=>{Export()}"/>
          <Button text="Import" :callback="()=>{Import()}" />
          <Button text="Delete All Data" :callback="()=>{DeleteAll()}" />  
  </div> -->

  <ModalVue v-if="show_modal"  :CloseModal="CloseModal" :modal_info="modal_info" />

  <div class="app" v-if="parent_loaded_can_mount_children">
    
  <div v-if="testing_input">
    <InputTextSmart  :default_value="input_def_value" :show_submit_btn="false" placeholder="Enter an attribute name"  :previous_entries_in="input_test_data" />
  </div>

  <!-- If not testing -->
  <div v-else >
    
    <!-- <ChooseCategory :SwitchScreen="SwitchScreen"/> -->
    <!-- <div v-if="Home||editing_cat_from_entry_list" v-show="Home"> -->
		<div v-show="Home"> <!-- Changing it so it's always in the background/ doesn't get destroyed-->
		<!-- should stay in the background if editing a cat from the home page-->


 
    <div v-if="!signed_in_to_google">
        <h1 style="text-align: center; margin:20px 0; margin-top:40px;">Welcome to Ackmi Health Tracker</h1>

        <button id="google-signin-btn"  @click="()=>{SignInToGoogle()}">
            <img src="/assets/img/g-logo.png" alt="Google logo" />
            Sign in with Google
        </button>

        <h3>Screenshots:</h3>
        <div class="screenshots">
            <img src="/assets/img/screenshots/health_tracker_main_screen.jpg"/>
            <img src="/assets/img/screenshots/health_tracker_input.jpg"/>
        </div>
        
        <!-- For having an official google sign i button: -->

        




		<!-- <button @click="()=>{SignInToGoogle()}">Sign In</button> -->
	</div>




	<!-- If signed in to google -->
	<div v-else>

      <!-- <ChooseCategory :user="user_current" :SwitchScreen="SwitchScreen"  :ShowModal="ShowModal"/> -->
	  <!-- Going to use scroller her to allow things to use it to scroll up/ down the page -->

	  <!-- 2026-06-26 - updating it so entire page scrolls, instead of just div -->
      <!-- <div id="scroller" style="height: calc(100svh - 55px); overflow-y: auto; scrollbar-width: thin;"> -->
		<div id="scroller" style="padding-bottom:55px">

        <!-- <div class="export_import2">
          <Button text="Export" :callback="()=>{Export()}"/>
          <Button text="Import" :callback="()=>{Import()}" />
			<Button text="Sign Out" :callback="()=>{SignOut()}" />

      </div> -->

        <!-- <UserSelectVue :users="users" :user_current="user_current" :UserSelected="UserSelected"  :ShowModal="ShowModalAdvanced" :AddUser="AddUser" :SwitchScreen="SwitchScreen"/>
         -->
		 <EntryList :ShowModal="ShowModalAdvanced" 
		 	
			:BackButtonRegister="BackButtonRegister"
			:MoveForwardToPage="MoveForwardToPage"
			:MoveBack="SwitchScreen"
			
			:GetEntriesByDateRange="GetEntriesByDateRange"
		 	:categories="cats"
			:DeleteEntryClicked="DeleteEntryClicked"
			:GetPrevEntriesForCat="GetPrevEntriesForCat"
        	:GetPrevAttributesForCat="GetPrevAttributesForCat"
			:AddOrEditEntry="AddOrEditEntry"
			:AttributeCreateUpdateOrDelete="AttributeCreateUpdateOrDelete"

			:entries="entries"
			:cats_w_entries="cats_w_entries"
			:GetEntriesInCatsByDateRange="GetEntriesInCatsByDateRange"
			:SetupCats="SetupCats"
            :ReloadPage="ReloadPage"
			:GetEntriesBySearch="GetEntriesBySearch"
            

		 ref="entrylist"/>


      </div>

	  <!-- Just a wrapper for the button so it can have a dark background to cover up text behind it -->
	  <div id="btn_enter_entry_BG">
      	<Button text="Enter New Entry" class="btn_enter_entry" :callback="SwitchToEntryInput" :wrap_txt="false"/>
		</div>


	  </div>

      
    </div>
    <!-- <EntryScreen v-if="EntryInputScreen"  :SwitchScreen="SwitchScreen" :extra="extra_data"/> -->
    <EntryInputScreen v-if="OnEntryInputScreen||OnCatEditScreen" v-show="OnEntryInputScreen"  

	:BackButtonRegister="BackButtonRegister"
	:MoveForwardToPage="MoveForwardToPage"
	:MoveBack="SwitchScreen"
		
		:extra="extra_data" :AddEntry="AddOrEditEntry" 
		:GetPrevEntriesForCat="GetPrevEntriesForCat" :GetPrevAttributesForCat="GetPrevAttributesForCat"
		:cats="cats"
		:ShowModal="ShowModalAdvanced"
		:DeleteEntryClicked="DeleteEntryClicked"
		:AttributeCreateUpdateOrDelete="AttributeCreateUpdateOrDelete"
		
		ref="entry_input"
		/>

    <UserEditScreen v-if="OnUserEditScreen"  :SwitchScreen="SwitchScreen" :extra="extra_data" :ShowModal="ShowModalAdvanced" :ReloadPage="ReloadPage"/>

    <CatEditScreen  v-if="OnCatEditScreen"
	  
	  :extra="extra_data" :ShowModal="ShowModalAdvanced" 

	:BackButtonRegister="BackButtonRegister"
	:MoveForwardToPage="MoveForwardToPage"
	:MoveBack="SwitchScreen"

	:ReloadPage="ReloadPage"
	:AddOrEditCat="AddOrEditCat"
	:CategoryDelete="CategoryDelete"
	 />

    </div>
    
    <!-- <button @click='GoogleSignInCapacitor' style="margin-top:50px;">Sign In with Google using capacitor2</button> -->
    

</div>
  <!-- <EntryScreen v-if="ChooseCat"/> -->
  <!-- <Category v-for="(cat, i) in categories"  :text="cat.name"  :icon="cat.icon" :bg_color="cat.bg_color" :txt_color="cat.txt_color"/> -->

  <!-- <Category/>
  <Category bg_color="blue" icon="favorite" text="Had Sex"/>
  <Category bg_color="red" icon="search" text="Looking..."/>
  <Category  icon="search" text="ewwewe..."/> -->
  
  
  <!-- <header>
    
    <img alt="Vue logo" class="logo" src="@/assets/logo.svg" width="125" height="125" />

    <div class="wrapper">
      <HelloWorld msg="You did it!" />

      <nav>
        <RouterLink to="/">Home</RouterLink>
        <RouterLink to="/about">About</RouterLink>
      </nav>
    </div>
  </header> -->

  <!-- Have to have this to use view router- which is pretty useless if you want to share data between components/ pass an object/ prop to another screen -->
  <!-- <RouterView /> -->
  
</template>

<style>

.export_import2
{
  position: absolute;
  right:100px;
  z-index: 999;
}

.app
{
  max-width: 960px;
  margin: 0 auto;
  /* padding: .5rem; */
  /* padding-left:50px;
  padding-right:100px; */
  font-weight: normal;
}
.material-icons {
  font-family: 'Material Icons';
  font-weight: normal;
  font-style: normal;
  font-size: 24px;  /* Preferred icon size */
  display: inline-block;
  line-height: 1;
  text-transform: none;
  letter-spacing: normal;
  word-wrap: normal;
  white-space: nowrap;
  direction: ltr;

  /* Support for all WebKit browsers. */
  -webkit-font-smoothing: antialiased;
  /* Support for Safari and Chrome. */
  text-rendering: optimizeLegibility;

  /* Support for Firefox. */
  -moz-osx-font-smoothing: grayscale;

  /* Support for IE. */
  font-feature-settings: 'liga';
}
#btn_enter_entry_BG
{
	background: var(--color-background);
	position: fixed;
	max-width: 960px;
	z-index: 100;
	bottom: 0;
	padding-top:10px;
	margin:0 auto;
	width:100%;
}
body div .btn_enter_entry
{
  width:100%;
  display:block;
  margin:0 auto;
  
  
  /* position: fixed !important;
  bottom:0;
  left:50%;
  transform: translateX(-50%);
  width:100vw;
  max-width: 960px;
  margin:0 !important;
  margin-bottom: 10px !important;
  padding:20px; */
}

</style>
<style scoped>


</style>
